import * as iconData from '@maui/icon-data'

const alertCircle = {
  d: iconData.alertCircle?.path,
  transform: 'translate(-8px, -8px)'
}

const blankPaper = {
  d: iconData.blankPaper__uno?.path,
  transform: 'translate(-6px, -6px)'
}

const bug = {
  d: iconData.bug__uno?.path,
  transform: 'translate(-9px, -9px)'
}

const eventTag = {
  d: iconData.tag__uno?.path,
  transform: 'translate(-8px, -8px)'
}

const key = {
  d: iconData.key__uno?.path,
  transform: 'translate(-8px, -7px)'
}

const mitre = {
  d: iconData.mitre__uno?.path,
  transform: 'translate(-8px, -8px)'
}

const mandiantTechnique = {
  d: 'M13.9623 3.61426H14V0.923035H11.7699L6.77187 7.79102L1.79091 0.923035H0V13.1078H2.2873V5.10587L6.11609 10.3703H7.44467L10.9352 5.5828C11.1641 5.26913 11.418 4.97455 11.6944 4.70195L11.7127 4.6837C12.0649 4.31293 12.476 4.00296 12.9293 3.76634C13.2522 3.61861 13.6105 3.56586 13.9623 3.61426ZM12.4077 6.02335C12.8302 5.60151 13.4029 5.36472 14 5.36504V13.1054H11.7468V7.61462C11.7474 7.01756 11.9851 6.44519 12.4077 6.02335Z',
  transform: 'translate(-7px, -7px)'
}

const notepad = {
  d: iconData.notepad__uno?.path,
  transform: 'translate(-8px, -8px)'
}

const phishing = {
  d: iconData.mailBug__uno?.path,
  transform: 'translate(-8px, -6px)'
}

const shieldAlert = {
  d: iconData.shieldAlert__uno?.path,
  transform: 'translate(-8px, -8px)'
}

const userSecret = {
  d: iconData.userSecret__uno?.path,
  transform: 'translate(-9px, -8px)'
}

export const timelineIcons = {
  'Actor Association Tag': userSecret,
  'CISA Remediation date': shieldAlert,
  'Date added to CISA Catalog': shieldAlert,
  'Date of Disclosure': bug,
  Event: eventTag,
  'Exploit Release Date': notepad,
  'First Observed Activity': alertCircle,
  'First published date': blankPaper,
  'Key Event': eventTag,
  'Key Host Command': key,
  'Malicious Executable Compiled': bug,
  'Malware Association Tag': bug,
  'Mandiant Declared Campaign': mandiantTechnique,
  'Mandiant Observed First Activity of Campaign': alertCircle,
  'Mandiant Technique': mandiantTechnique,
  Merged: userSecret,
  'Mitre Association Tag': mitre,
  'New x509 SSL Certificate': key,
  'New x509 SSL Certificate Created': key,
  'New x509 Code Signing': key,
  other: eventTag,
  'Phishing Email Sent': phishing,
  'Phishing Email Tag': phishing,
}

export const validTypes = []
